import Icon from '@/components/ui/AppIcon';

interface ExecutiveContact {
  name: string;
  title: string;
  department: string;
  email: string;
  phone: string;
  availability: string;
  specialization: string;
}

const ExecutiveContacts = () => {
  const executives: ExecutiveContact[] = [
    {
      name: 'Danny Clans',
      title: 'Founder',
      department: 'Leadership',
      email: 'danny@dannyclans.com',
      phone: '+44 7520656967',
      availability: 'Mon-Fri, 9:00-18:00 GMT',
      specialization: 'Company vision, strategic direction, enterprise partnerships'
    },
    {
      name: 'Aaryan Kapoor',
      title: 'Chief Operating Officer',
      department: 'Operations',
      email: 'collab@dannyclans.com',
      phone: '+44 7451 294021',
      availability: 'Mon-Fri, 9:00-18:00 GMT',
      specialization: 'Operations management, business development, client relations'
    },
    {
      name: 'Lucy Martin',
      title: 'Chief Technology Officer',
      department: 'Technical Infrastructure',
      email: 'help@dannyclans.com',
      phone: '+44 7853 123119',
      availability: 'Mon-Fri, 9:00-18:00 GMT',
      specialization: 'Platform integration, API architecture, white-label solutions'
    }
  ];

  return (
    <section className="bg-card border border-border rounded-sm p-8">
      <div className="flex items-center space-x-3 mb-8">
        <Icon name="UserGroupIcon" size={28} variant="solid" className="text-primary" />
        <h2 className="font-headline font-bold text-2xl text-primary">
          Executive Contact Directory
        </h2>
      </div>
      
      <p className="font-body text-base text-text-secondary mb-8 leading-relaxed">
        Direct access to department heads for enterprise-level inquiries. All executives maintain strict confidentiality protocols and respond personally to qualified inquiries.
      </p>
      
      <div className="space-y-6">
        {executives.map((exec, index) => (
          <div key={index} className="border border-border rounded-sm p-6 hover:border-accent transition-colors duration-smooth">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-4">
              <div>
                <h3 className="font-headline font-bold text-lg text-primary mb-1">
                  {exec.name}
                </h3>
                <p className="font-body text-sm text-text-secondary mb-1">
                  {exec.title}
                </p>
                <p className="font-accent text-xs text-accent">
                  {exec.department}
                </p>
              </div>
              
              <div className="mt-4 md:mt-0 flex items-center space-x-2">
                <Icon name="ClockIcon" size={16} variant="outline" className="text-success" />
                <span className="font-accent text-xs text-text-secondary">
                  {exec.availability}
                </span>
              </div>
            </div>
            
            <div className="space-y-3 mb-4">
              <div className="flex items-center space-x-3">
                <Icon name="EnvelopeIcon" size={18} variant="outline" className="text-accent" />
                <a 
                  href={`mailto:${exec.email}`}
                  className="font-body text-sm text-accent hover:text-primary transition-colors duration-smooth"
                >
                  {exec.email}
                </a>
              </div>
              
              <div className="flex items-center space-x-3">
                <Icon name="PhoneIcon" size={18} variant="outline" className="text-accent" />
                <a 
                  href={`tel:${exec.phone}`}
                  className="font-body text-sm text-accent hover:text-primary transition-colors duration-smooth"
                >
                  {exec.phone}
                </a>
              </div>
            </div>
            
            <div className="pt-4 border-t border-border">
              <p className="font-body text-sm text-text-secondary leading-relaxed">
                <span className="font-semibold text-primary">Specialization:</span> {exec.specialization}
              </p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-8 p-6 bg-muted rounded-sm">
        <div className="flex items-start space-x-3">
          <Icon name="InformationCircleIcon" size={24} variant="solid" className="text-accent mt-1" />
          <div>
            <h4 className="font-headline font-semibold text-sm text-primary mb-2">
              Enterprise Inquiry Protocol
            </h4>
            <p className="font-body text-sm text-text-secondary leading-relaxed">
              For accounts exceeding $100,000 monthly ad spend, direct executive contact is recommended. Include your company details, current platform challenges, and specific infrastructure requirements in your initial communication.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExecutiveContacts;